// extracted by mini-css-extract-plugin
export var container = "layout-module--container--qR6tl";
export var content = "layout-module--content--2sFCg";